<c-col class="d-flex justify-content-center pagination">
    <pagination-controls (pageChange)="changePage($event)" previousLabel="" nextLabel="" [autoHide]="true"></pagination-controls>
</c-col>